import React, { useEffect, useState } from 'react';
import { Router, Route } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import history from './config/history';
import { fireAuth } from './database/utils/firebase';
import { onUser } from './database/repositories/UserRepository';
import { getRouteNames } from './database/repositories/PlanRepository';
import { logIn, updateUserData, setUserPhotoURL } from './store/ducks/auth';
import { getUserPhotoURL } from './database/utils/storage';
import Routes, { NoPermissionPage } from './routes';

function App() {
  const userData = useSelector((state) => state.auth.user_data);
  const userID = useSelector((state) => state.auth.uid);
  const dispatcher = useDispatch();
  const [permission, setPermission] = useState([]);

  useEffect(() => {
    let unsubscribe;
    const unsubscribeFromAuth = fireAuth.onAuthStateChanged(async (user) => {
      if (!user) {
        if (unsubscribe) unsubscribe();
        return;
      }

      dispatcher(logIn(user.uid, user.email));
      unsubscribe = onUser(user.uid, (newUserData) => dispatcher(updateUserData(newUserData)));
    });
    return () => {
      unsubscribeFromAuth();
      if (unsubscribe) unsubscribe();
    };
  }, []);

  function checkPermissions(path) {
    return permission.length === 0 || permission.includes(path);
  }

  useEffect(() => {
    if (!userData || !userID) return;
    getRouteNames(userData.plan).then(setPermission);
    getUserPhotoURL(userID, userData.photo)
      .then((url) => dispatcher(setUserPhotoURL(url)))
      .catch(console.error);
  }, [userID, userData?.photo]);

  return (
    <Router history={history}>
      {Routes.map((router) => {
        return (
          <Route
            key={router.component.name}
            path={router.path}
            exact={!!router.exact}
            component={
              router.noCheck || checkPermissions(router.component.name)
                ? router.component
                : NoPermissionPage
            }
          />
        );
      })}
      )
    </Router>
  );
}

export default App;
